import { motion } from 'framer-motion/dist/framer-motion';
import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';
import { Section } from '../Home.style';

export const MemberShipBackground = styled.div`
  background: center / cover no-repeat url('/imgs/webp/home/member.webp');
`;

export const MemberShipContainer = styled(Section)`
  margin-top: 0;
  margin-bottom: 0;
  line-height: normal;
  width: 100%;
  padding-top: var(--home-block-padding);
  padding-bottom: var(--home-block-padding);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  ${flexGap('24px')}
`;

export const MemberBenefitContainer = styled.article`
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  padding: 16px 32px;
  padding-bottom: 0;
  & > *:not(:last-child) > * {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 757px) {
    padding: 16px;
    padding-bottom: 8px;
    & > *:nth-child(4) > *:not(:last-child) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
`;

export const MemberBenefitRow = styled.div`
  display: flex;
  font-size: var(--fs-600);

  & > * {
    flex: 1;

    padding-top: 16px;
    padding-bottom: 16px;
    ${flexGap('16px')}
  }

  @media (max-width: 757px) {
    flex-direction: column;
    & > * {
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
`;

export const MemberShipContent = styled.div`
  h2 {
    font-size: var(--fs-1000);
    color: #fff;
    margin-bottom: 24px;
    font-weight: 700;
  }
  h3 {
    font-size: var(--fs-800);
    color: #fff;
    margin-bottom: 48px;
  }
  h5 {
    font-weight: 700;
    margin: 0;
    padding: 0;
    padding-bottom: 24px;
    font-size: var(--fs-800);
    color: #07080a;
  }
  @media (max-width: 1380px) {
    h3 {
      margin-bottom: 40px;
    }
  }
  @media (max-width: 757px) {
    flex: 1 1 auto;
    h2 {
      margin-bottom: 16px;
    }
    h3 {
      margin-bottom: 24px;
    }
    h5 {
      padding-bottom: 16px;
    }
  }
`;

export const MemberShipButton = styled(motion.button)`
  display: flex;
  align-items: center;
  padding: 16px 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  font-weight: 700;
  font-size: var(--fs-800);
  text-align: center;
  color: #07080a;
  cursor: pointer;
  ${flexGap('8px')}

  @media (max-width: 757px) {
    padding: 8px 16px;
    ${flexGap('24px')}
  }
`;
